/** CoStar.Api.ListingMarketplace.AuctionReports.ViewModels.DocumentType */
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Unknown"] = 0] = "Unknown";
    DocumentType[DocumentType["Title"] = 1] = "Title";
    DocumentType[DocumentType["Environmental"] = 2] = "Environmental";
    DocumentType[DocumentType["PCA"] = 3] = "PCA";
    DocumentType[DocumentType["LimitedPhaseOne"] = 4] = "LimitedPhaseOne";
})(DocumentType || (DocumentType = {}));
/** CoStar.Api.ListingMarketplace.AuctionReports.ViewModels.AuctionReportStatus */
export var AuctionReportStatus;
(function (AuctionReportStatus) {
    AuctionReportStatus[AuctionReportStatus["Unknown"] = 0] = "Unknown";
    AuctionReportStatus[AuctionReportStatus["NotRequired"] = 10] = "NotRequired";
    AuctionReportStatus[AuctionReportStatus["TenxOrderRequested"] = 20] = "TenxOrderRequested";
    AuctionReportStatus[AuctionReportStatus["SellerOrderRequested"] = 30] = "SellerOrderRequested";
    AuctionReportStatus[AuctionReportStatus["Ordered"] = 40] = "Ordered";
    AuctionReportStatus[AuctionReportStatus["Received"] = 50] = "Received";
    AuctionReportStatus[AuctionReportStatus["PendingRevisions"] = 60] = "PendingRevisions";
    AuctionReportStatus[AuctionReportStatus["InDataRoomPublic"] = 70] = "InDataRoomPublic";
    AuctionReportStatus[AuctionReportStatus["Rejected"] = 100] = "Rejected";
})(AuctionReportStatus || (AuctionReportStatus = {}));
